import React from 'react';
// @ts-ignore
import logoGovCO from '../assets/logoGovCO.png';

export const GovBar: React.FC = () => (
  <div className="w-full bg-[#0943B5] px-6 md:px-16" style={{ height: '56px' }}>
    <div className="max-w-6xl mx-auto h-full flex items-center justify-center md:justify-start">
    <a
      href="https://www.gov.co"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="GOV.CO - Portal del Estado Colombiano"
      className="flex items-center focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#0943B5] rounded"
      style={{ minWidth: '44px', minHeight: '44px' }}
    >
      <img
        src={logoGovCO}
        alt="GOV.CO - Portal del Estado Colombiano"
        style={{ height: '24px', width: 'auto' }}
      />
    </a>
    </div>
  </div>
);
